import React from 'react';
import { InternalAuditorTemplate } from '../components/training/templates/InternalAuditorTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getInternalAuditorContent } from '../data/standards/trainingContent';

export const IATF16949InternalAuditor = () => {
  const standard = getStandardBySlug('iatf-16949');
  const content = getInternalAuditorContent('iatf-16949');

  return <InternalAuditorTemplate standard={standard} content={content} />;
};
